<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-combobox
                                        :items="filteredGlobalProviders"
                                        label="Select a Provider"
                                        item-value="_id"
                                        item-text="Name"
                                        return-object
                                        @change="updateInfo"
                                        v-model="newGlobalProvider"
                                        :readonly="!canUpdate"
                                        :disabled="!canUpdate"
                                    >
                                        <template v-slot:item="{ item }">
                                            {{ item.Name }} -
                                            <v-btn
                                                x-small
                                                color="success"
                                                dark
                                                class="ml-2"
                                            >
                                                {{ item.Profession }}
                                            </v-btn>
                                            <v-btn x-small color="teal" dark class="ml-2">
                                                {{ item.State }}
                                            </v-btn>
                                        </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="newName"
                                        label="Provider Name"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="newEmail"
                                        label="Email"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-autocomplete
                                        v-model="newProfession"
                                        label="Profession"
                                        :items="roles"
                                        readonly
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        label="Phone Number"
                                        v-model="newPhone"
                                        v-mask="'(###) ###-####'"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        label="Fax"
                                        v-model="newFax"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field
                                        v-model="newCompany"
                                        label="Facility"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="6">
                                    <v-text-field
                                        v-model="newAddress"
                                        label="Address"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="newCity"
                                        label="City"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="newState"
                                        label="State"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="newZip"
                                        label="Zip"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrint()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!createProvider"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addProvider()"
                            v-if="createProvider && !isAuditorRole"
                            :readonly="!canUpdate"
                            :disabled="!canUpdate"
                        >Save
                        </v-btn
                        >
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="updateProvider()"
                            v-if="!createProvider && !isAuditorRole"
                            :readonly="!canUpdate"
                            :disabled="!canUpdate"
                        >Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close"
                        >Cancel
                        </v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";
import {mapActions} from "vuex";
import {displayError, displaySuccess} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;

export default {
    components: {
        ClientNav,
        Foot,
    },
    data() {
        return {
            dialog: false,
            editProvider: false,
            newProvider: false,
            msg: false,
            search: "",
            text: "",
            providers: [],
            provider: {},
            units: [],
            codes: [],
            tempData: [],
            unitID: localStorage.getItem("unitID"),
            clientID: this.$route.params.clientID,
            providerId: this.$route.params.id,
            token: localStorage.getItem('token'),
            titleForm: "New Provider",
            newName: "",
            newEmail: "",
            newProfession: "",
            newCompany: "",
            newPhone: "",
            newFax: "",
            newAddress: "",
            newCity: "",
            newState: "",
            newZip: "",
            editedIndex: -1,
            editedItem: {
                name: "",
                email: "",
                profession: "",
                company: "",
                phone: "",
                fax: "",
                address: "",
                city: "",
                state: "",
                zip: "",
            },
            defaultItem: {
                name: "",
                email: "",
                profession: "",
                company: "",
                phone: "",
                fax: "",
                address: "",
                city: "",
                state: "",
                zip: "",
            },
            isLoading: true,
            roles: [
                "Admitting Physician",
                "Allergist",
                "Appointed Attorney",
                "Attending Physician",
                "Appointed Attorney",
                "Audiologist",
                "Behaviorist",
                "Cardiologist",
                "Care Worker Supervisor",
                "Case Worker",
                "Chiropractor",
                "Counselor/Therapist",
                "Dentist",
                "Dermatologist",
                "Ears, Nose and Throat (ENT)",
                "Emergency Room",
                "Employer",
                "Endocrinologist",
                "Gastroenterologist",
                "Gynecologist",
                "Hospital",
                "Legal Guardian",
                "Nephrologist",
                "Neurologist",
                "Nurse",
                "Nurse Practitioner",
                "Nutritionist/Dietician",
                "Occupational Therapist",
                "Oncologist",
                "Optometrist/Ophthalmologist",
                "Orthopedic",
                "Parent (Connect Access)",
                "Pharmacy",
                "Phlebotomist",
                "Physical Therapist",
                "Physician or Specialist",
                "Physician Assistant",
                "Podiatrist",
                "Primary Care MD",
                "Psychiatrist",
                "Public Guardian",
                "Radiologist",
                "Sleep Specialist",
                "Support Coordinator",
                "Surgeon",
                "Urologist",
                "Urgent Care",
                "Work Site",
                "Wound Care",
            ],
            globalProviders: [],
            newGlobalProvider: "",
            newStatus: "",
            newClients: [],
            listIndex: "",
            userState: localStorage.getItem("userState"),
            createProvider: false,
        };
    },

    computed: {
        filteredGlobalProviders() {
            const userState = this.userState;
            const globalProviders = [];
            const otherStatesProviders = [];

            for (const provider of this.globalProviders) {
                if (
                    (provider.State === "Utah" || provider.State === "UT") &&
                    (userState === "Utah" || userState === "UT")
                ) {
                    globalProviders.push(provider);
                } else if (
                    (provider.State === "Nevada" || provider.State === "NV") &&
                    (userState === "Nevada" || userState === "NV")
                ) {
                    globalProviders.push(provider);
                } else if (
                    userState !== "Utah" &&
                    userState !== "UT" &&
                    userState !== "Nevada" &&
                    userState !== "NV"
                ) {
                    if (
                        provider.State !== "Utah" &&
                        provider.State !== "UT" &&
                        provider.State !== "Nevada" &&
                        provider.State !== "NV"
                    ) {
                        globalProviders.push(provider);
                    } else {
                        otherStatesProviders.push(provider);
                    }
                } else {
                    otherStatesProviders.push(provider);
                }
            }

            return globalProviders.concat(otherStatesProviders);
        },

        canUpdate() {
            if (
                localStorage.getItem("userRole") === "Administration" ||
                localStorage.getItem("userRole") === "Program Coordinator" ||
                localStorage.getItem("userRole") === "Compliance Manager" ||
                localStorage.getItem("userRole") === "Human Resources" ||
                localStorage.getItem("userRole") === "Client Services Manager" ||
                localStorage.getItem("userRole") === "Medical Manager"
            ) {
                return true;
            }
            return false;
        },

        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {},

    created() {
        this.createProvider = this.$route.query.createProvider === 'true';
        this.getProviders();
        this.getGlobalProviders();
    },

    mounted() {
        if (!this.createProvider) {
            this.getProvider();
        }

        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.providerId, this.token,'Provider');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.providerId, this.token, 'Provider');
        });
    },

    methods: {
        ...mapActions({
            getClientProviders: "clientProviders/getItem",
            addItem: "clientProviders/addItem",
            updateItem: "clientProviders/updateItem",
            deleteItem: "clientProviders/deleteItem",
        }),

        initialize() {
            this.providers = [];
        },

        viewProvider(item) {
            this.titleForm = "Viewing " + item.Provider.Name;
            this.newName = item.Provider.Name;
            this.newEmail = item.Provider.Email;
            this.newProfession = item.Provider.Profession;
            this.newCompany = item.Provider.Company;
            this.newPhone = item.Provider.Phone;
            this.newFax = item.Provider.Fax;
            this.newAddress = item.Provider.Address;
            this.newCity = item.Provider.City;
            this.newState = item.Provider.State;
            this.newZip = item.Provider.Zip;
            this.newGlobalProvider = item.Provider;
            this.providerId = item._id;
        },

        clearData() {
            this.newName = "";
            this.newEmail = "";
            this.newProfession = "";
            this.newCompany = "";
            this.newPhone = "";
            this.newFax = "";
            this.newAddress = "";
            this.newCity = "";
            this.newState = "";
            this.newZip = "";
            this.newGlobalProvider = "";
            this.newStatus = "";
        },

        close() {
            this.$router.go(-1);
            this.clearData();
        },

        async getProviders() {
            const response = await this.getClientProviders(this.clientID);
            this.providers = response.data;
        },

        async getProvider() {
            const response = await axios.get(`${url}/client-provider/specific/${this.providerId}`);
            this.provider = response.data.provider;
            this.viewProvider(this.provider);
        },

        getGlobalProviders: function () {
            this.isLoading = true;
            axios
                .get(`${url}/providers`)
                .then((res) => {
                    this.globalProviders = res.data.providers;
                })
                .finally(() => (this.isLoading = false));
        },

        async addProvider() {
            try {
                const data = {
                    providerId: this.newGlobalProvider._id,
                    clientId: this.clientID,
                };
                await this.addItem(data);
                await this.getProviders();
                displaySuccess("The new provider has been added successfully.");
            } catch (e) {
                displayError("An Error has occurred while adding the provider" + e);
            } finally {
                this.close();
            }
        },

        async updateProvider() {
            try {
                const data = {
                    id: this.providerId,
                    data: {
                        providerId: this.newGlobalProvider._id,
                    },
                };
                await this.updateItem(data);
                await this.getProviders();
                displaySuccess("The provider has been updated successfully.");
            } catch (e) {
                displayError("An Error has occurred while updating the provider" + e);
            } finally {
                this.close();
            }
        },

        updateInfo() {
            this.newName = this.newGlobalProvider.Name;
            this.newEmail = this.newGlobalProvider.Email;
            this.newProfession = this.newGlobalProvider.Profession;
            this.newCompany = this.newGlobalProvider.Company;
            this.newPhone = this.newGlobalProvider.Phone;
            this.newFax = this.newGlobalProvider.Fax;
            this.newAddress = this.newGlobalProvider.Address;
            this.newCity = this.newGlobalProvider.City;
            this.newState = this.newGlobalProvider.State;
            this.newZip = this.newGlobalProvider.Zip;
            this.newClients = this.newGlobalProvider.Clients;
        },

        async generateDownloadUrl() {
            return `${url}/client-provider/print-pdf?id=${this.providerId}`;
        },

        async showPrint() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.providerId, this.token, 'Provider');
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
